import { useQuery } from '@tanstack/react-query';
import { fetchAutoPricerIntervals } from '../helpers/api';

export const useQueryAutopricerIntervals = () => {
  const { data, isFetching, status, error, refetch } = useQuery({
    queryKey: [`/autopricer/intervals`],
    queryFn: () => fetchAutoPricerIntervals(),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });
  return {
    data,
    isFetching,
    status,
    error,
    refetch,
  };
};
